module.exports = __webpack_public_path__ + "img/blue_001.08390b49.png";